














































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import ReportTableComponent from "@/components/common/Tables/ReportTable.vue";
import { ReportFilter, ReportParameter } from "@/entities";
import { Locales } from "@/i18n/locales";

@Component({
  components: {
    ReportTableComponent
  }
})
export default class ImplProgressReportComponent extends Vue {

    selectedParams: Array<ReportParameter> = [];
    data: any = [];
    fields: Array<ReportFilter> = [];
    isLoading: boolean = false;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;
    headers: any = [
        { text: "Initiative", value: "Initiative", sortable: false },
        { text: "Region", value: "Region", sortable: false },
        { text: "Country", value: "Country", sortable: false },
        { text: "Grant Type", value: "GrantType", sortable: false },
        { text: "Grant Code", value: "GrantCode", sortable: false },
        { text: "Project Title", value: "ProjectTitle", sortable: false },
        { text: "Requested", value: "RequestedAmount", align: 'right', sortable: false },
        { text: "Spent", value: "Spent", align: 'right', sortable: false },
        { text: "% of Spending", value: "PercentageOfSpending", align: 'right', sortable: false },
        { text: "Forecast", value: "Forecast", align: 'right', sortable: false },
        { text: "Balance Remaining", value: "BalanceRemaining", align: 'right', sortable: false },
        { text: "Grant Closing Date", value: "GrantClosingDate", sortable: false },
        { text: "Grant Approval Date", value: "GrantSignDate", sortable: false },
    ];
    dynamicSlots = {
        vDataTable:[
            {
                name:'item.RequestedAmount'
            },
            {
                name:'item.Spent'
            },
            {
                name: 'item.Forecast'
            },
            {
                name: 'item.BalanceRemaining'
            },
            {
                name: 'item.GrantClosingDate'
            },
            {
                name: 'item.GrantSignDate'
            }
        ]
    };

     mounted() {
        this.$services.implentationProgressReport.getFilters().then((resp: any) => {
        this.fields = resp;
        });
    }


    // generate the report
    generateReport() {
        this.data = [];
        this.isLoading = true;
        this.$services.implentationProgressReport
        .generateReport(this.selectedParams)
        .then((resp: any) => {
            this.isLoading = false;
            this.data = resp.data;
        });
    }
}
